// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Retarget = function Retarget(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M13.63 7.147a5.664 5.664 0 00-4.77-4.86v-1.06H7.14v1.06a5.664 5.664 0 00-4.77 4.86H1.23v1.71H2.4a5.657 5.657 0 004.74 4.67v1.25h1.72v-1.25a5.657 5.657 0 004.74-4.67h1.17v-1.71zm-4.77 4.64v-2.04H7.14v2.04a3.953 3.953 0 01-3-2.93h2.11v-1.71H4.09a3.976 3.976 0 013.05-3.11v2.22h1.72v-2.22a3.976 3.976 0 013.05 3.11H9.75v1.71h2.11a3.952 3.952 0 01-3 2.93z"
    }))
  );
};

export default Retarget;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Retarget.js
// module id = 1045
// module chunks = 0